import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-sales') || document.getElementById('page-reform')) {
  const uploadFile = document.querySelectorAll('.js-upload-file')
  uploadFile.forEach(function (elem) {
    elem.addEventListener('change', function () {
      if (elem.value !== '') {
        elem.nextElementSibling.classList.remove('active')
        elem.nextElementSibling.nextElementSibling.classList.add('active')
      } else {
        elem.nextElementSibling.classList.add('active')
        elem.nextElementSibling.nextElementSibling.classList.remove('active')
      }
    })
  })

  const clearbtn = document.querySelectorAll('.js-upload-clear')
  clearbtn.forEach(function (elem) {
    elem.addEventListener('click', function () {
      elem.classList.remove('active')
      elem.previousSibling.previousSibling.classList.add('active')
      console.log('elem.previousSibling: ' + elem.previousSibling)
      console.log('elem.previousSibling.previousSibling: ' + elem.previousSibling.previousSibling)
      const input = elem.previousSibling.previousSibling.previousSibling
      input.value = ''
    })
  })
}
